import { isEmptyString } from 'utils/stringHelpers';

export const getCleanValues = (values: string[]) => {
  const trimmedValues = values.map((value) => value.trim());
  const removedEmptyValues = trimmedValues.filter((value) => !isEmptyString(value));
  const removedDuplicateValues = [...new Set(removedEmptyValues)];
  return removedDuplicateValues;
};
